import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

export const getPagos = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/finanzas`, { headers });
  return response.data;
};

export const getPagoById = async (id) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/finanzas/${id}`, {
    headers,
  });
  return response.data.data;
};

export const createPago = async (pagoData) => {
  const token = localStorage.getItem("authToken"); // Obtén el token del almacenamiento local
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.post(`${API_BASE_URL}/createFinanzas`, pagoData, {
    headers,
  });
  return response.data;
};

export const updatePago = async (id, pagoData) => {
  const token = localStorage.getItem("authToken"); // Asegúrate de que este token sea válido
  const headers = { Authorization: `${token}` };
  const response = await axios.put(`${API_BASE_URL}/finanzas/${id}`, pagoData, {
    headers,
  });
  return response.data;
};


export const deletePago = async (id) => {
  const token = localStorage.getItem("authToken"); // Obtén el token del almacenamiento local
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.delete(`${API_BASE_URL}/finanzas/${id}`, {
    headers,
  });
  return response.data;
};
